import { processValidationRule } from './processValidationRule';
/**
 * Transforms a set of validation rules into a format compatible with react-hook-form's RegisterOptions.
 *
 * @param {FieldValidation} validation - An object containing validation rules.
 * @returns {RegisterOptions} - An object formatted as react-hook-form's RegisterOptions, with transformed validation rules.
 */
export const transformValidationRules = (validation) => {
    if (!validation)
        return {};
    const { required, min, max, minLength, maxLength, pattern } = validation;
    return {
        required: required && processValidationRule(required),
        min: min && processValidationRule(min, Number),
        max: max && processValidationRule(max, Number),
        pattern: pattern && processValidationRule(pattern, (patternValue) => new RegExp(patternValue)),
        minLength: minLength && processValidationRule(minLength, Number),
        maxLength: maxLength && processValidationRule(maxLength, Number)
    };
};
